import React, { useState } from 'react';
import {
  FaShieldAlt, FaUser, FaShoppingCart, FaCreditCard, FaServer,
  FaExclamationTriangle, FaUserCog, FaBoxes, FaBell, FaTruck, FaGlobe, FaStore,
} from 'react-icons/fa';

import AuthenticationLog  from './pages/AuthenticationLog';
import UserActivityLog    from './pages/UserActivityLog';
import OrderLog           from './pages/OrderLog';
import OrderStatusLog     from './pages/OrderStatusLog';
import PaymentLog         from './pages/PaymentLog';
import ApiLog             from './pages/ApiLog';
import ErrorLog           from './pages/ErrorLog';
import AdminActivityLog   from './pages/AdminActivityLog';
import InventoryLog       from './pages/InventoryLog';
import NotificationLog    from './pages/NotificationLog';
import ShipmentLog        from './pages/ShipmentLog';
import VisitPageLog       from './pages/VisitPageLog';
import RboActivityLog     from './pages/RboActivityLog';

import '../../css/admin/ActivityLogs.css';

const TABS = [
  { id: 'authentication_logs',  label: 'Authentication', icon: <FaShieldAlt />,          color: '#3B82F6', component: <AuthenticationLog /> },
  { id: 'user_activity_logs',   label: 'User Activity',  icon: <FaUser />,               color: '#10B981', component: <UserActivityLog />   },
  { id: 'rbo_activity_logs',    label: 'RBO Activity',   icon: <FaStore />,              color: '#F97316', component: <RboActivityLog />    },
  { id: 'order_logs',           label: 'Orders',         icon: <FaShoppingCart />,        color: '#F55D00', component: <OrderLog />          },
  { id: 'order_status_logs',    label: 'Order Status',   icon: <FaStore />,               color: '#F97316', component: <OrderStatusLog />   },
  { id: 'payment_logs',         label: 'Payments',       icon: <FaCreditCard />,          color: '#8B5CF6', component: <PaymentLog />        },
  // { id: 'api_logs',             label: 'API',            icon: <FaServer />,              color: '#06B6D4', component: <ApiLog />            },
  // { id: 'error_logs',           label: 'Errors',         icon: <FaExclamationTriangle />, color: '#EF4444', component: <ErrorLog />          },
  // { id: 'admin_activity_logs',  label: 'Admin Activity', icon: <FaUserCog />,             color: '#FDBF50', component: <AdminActivityLog />  },
  { id: 'inventory_logs',       label: 'Inventory',      icon: <FaBoxes />,               color: '#84CC16', component: <InventoryLog />      },
  { id: 'notification_logs',    label: 'Notifications',  icon: <FaBell />,                color: '#EC4899', component: <NotificationLog />   },
  { id: 'shipment_logs',        label: 'Shipments',      icon: <FaTruck />,               color: '#14B8A6', component: <ShipmentLog />       },
  { id: 'visit_page_logs',      label: 'Page Visits',    icon: <FaGlobe />,               color: '#A855F7', component: <VisitPageLog />      },
];

const ActivityLogs = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const current = TABS.find(t => t.id === activeTab);

  return (
    <div className="al-wrap">
      {/* Page heading */}
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Activity Logs</h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
          Monitor all platform events across every module in real-time.
        </p>
      </div>

      {/* Tab bar */}
      <div className="al-tabs">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`al-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            style={activeTab === tab.id ? {} : { '--tab-color': tab.color }}
          >
            <span className="al-tab-icon" style={{ color: activeTab === tab.id ? '#fff' : tab.color }}>
              {tab.icon}
            </span>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active page */}
      {current?.component}
    </div>
  );
};

export default ActivityLogs;
